import useBrowserDimensions from './use-browser-dimensions.js';

var useBreakpoints = styles => {
  var _useBrowserDimensions = useBrowserDimensions(),
      browserWidth = _useBrowserDimensions.width;

  var isCurrentBreakpoint = breakpoint => browserWidth < Number.parseInt(styles[breakpoint], 10);

  var getNumberOfDisplayedItems = (breakpointColumnMapping, defaultAmount) => {
    var currentBreakpoint = Object.keys(breakpointColumnMapping).find(isCurrentBreakpoint);
    return !currentBreakpoint ? defaultAmount : breakpointColumnMapping[currentBreakpoint];
  };

  return {
    isCurrentBreakpoint,
    getNumberOfDisplayedItems
  };
};

export { useBreakpoints };
//# sourceMappingURL=use-breakpoints.js.map
